import Request from "@/common/net/request.js";
const request = new Request();
// 资金流水列表
export function getPage(data) {
  return request.send({
    url: `/pmy/paycenter/fund/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 导出资金流水
export function downloadTable(data) {
  return request.send({
    url: `/pmy/paycenter/fund/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 导出资金流水
export function overviewMethod(data) {
  return request.send({
    url: `/pmy/paycenter/fund/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
